export const formatTelNumber = (str: string, phonePrefix?: string) => {
  let result = str;
  result = result.replaceAll(" ", "");
  result = result.replaceAll("-", "");
  if (phonePrefix?.length) {
    result = result.replace(/^0/, ""); // remove leading zero
    result = `${phonePrefix}${result}`;
  }
  return result;
};
